import React, { useState } from "react";
import { Checkbox, Container, FormControlLabel, Stack, TextField, Typography, useMediaQuery } from "@mui/material";
import { tablet } from "utils";
import { Button } from "components/Button";
import { Button as MuiButton } from "@mui/material";

export const ReportForm = ({ title, submit, isLoading }) => {
  const matchesTablet = useMediaQuery(tablet);

  const [consent, setConsent] = useState();
  const [company, setCompany] = useState();
  const [error, setError] = useState();
  const [triedToSubmit, setTriedToSubmit] = useState();

  const onlyNumbersRegExp = /^[0-9]*$/;

  const handleChange = (e) => {
    if (onlyNumbersRegExp.test(e.target.value)) {
      setCompany(e.target.value);
    } else {
      setCompany((prev) => prev || "");
    }

    if (triedToSubmit && e.target.value.length !== 7 && e.target.value.length !== 9) {
      setError("Įmonės kodas turi būti sudarytas iš 7 arba 9 skaitmenų.");
    } else {
      setError("");
    }
  };

  const handleCheckboxChange = () => {
    setConsent(!consent);
  };

  const handleSubmit = () => {
    if (company?.length !== 7 && company?.length !== 9) {
      setTriedToSubmit(true);
      setError("Įmonės kodas turi būti sudarytas iš 7 arba 9 skaitmenų.");
    } else {
      setTriedToSubmit(false);
      submit(company);
    }
  };

  const finPassTermsConditions = () => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "/Finpass_terms_conditions.pdf", true);
    xhr.responseType = "blob";

    xhr.onload = function (e) {
      if (this.status === 200) {
        const myBlob = this.response;
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(myBlob);
        link.download = "Finpass_terms_conditions.pdf";
        link.click();
      }
    };
    xhr.send();
  };

  return (
    <Stack spacing={2} alignItems="center">
      {title}
      <Container maxWidth="sm">
        <TextField
          name="company code"
          variant="standard"
          fullWidth
          value={company}
          onChange={handleChange}
          helperText={
            <Typography fontSize="12px" fontWeight={400} textAlign="center">
              {error}
            </Typography>
          }
          sx={{
            input: {
              textAlign: "center",
              fontSize: matchesTablet ? "24px" : "36px",
              fontWeight: "900",
              color: "primary.main",
              fontFamily: "Swedbank Headline",
            },
            ".MuiInput-root:before": {
              borderBottom: (theme) => `2px solid ${theme.palette.primary.main}`,
            },
          }}
        />
      </Container>

      <FormControlLabel
        control={<Checkbox checked={consent} onChange={handleCheckboxChange} />}
        label={
          <Stack direction="row" alignItems="center">
            <Typography
              color="textGrey.main"
              sx={{
                fontSize: matchesTablet ? "15px" : "17px",
                fontWeight: matchesTablet ? "400" : "500",
              }}
            >
              Supratau ir sutinku su{" "}
            </Typography>

            <MuiButton
              variant="text"
              disableRipple
              onClick={(e) => {
                e.stopPropagation();
                finPassTermsConditions();
              }}
              sx={{
                py: 0,
                px: "0.4rem",
                "&:hover": {
                  background: "none",
                },
              }}
            >
              <Typography
                color="primary"
                matchesMobile={matchesTablet}
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: matchesTablet ? "15px" : "17px",
                  fontWeight: matchesTablet ? "400" : "500",
                }}
              >
                taisyklėmis
              </Typography>
            </MuiButton>
          </Stack>
        }
      />

      <Button onClick={handleSubmit} disabled={!company || !consent} loading={isLoading}>
        Tikrinti įmonę
      </Button>
    </Stack>
  );
};
